<!--
 * @Author: Tang Hao
 * @Date: 2025-12-22 14:00:17
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-12-22 15:36:04
 * @Description:
-->
<template>
  <div>
    <div>
      该红包池关联的提现费用按照以下设置的税率点进行基础服务费的计算
    </div>
    <el-input-number :disabled="disabled" v-model="num" @change="handleChange" :min="0"></el-input-number> %
  </div>
</template>

<script>

export default {
  name: 'Payment',
  props: {
    value: [Number, String],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value() {
      this.num = this.value;
    },
  },
  data() {
    return {
      num: '',
    };
  },

  methods: {
    handleChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="less" scoped></style>
